import React from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { style } from './style';

export const MissingRatesDefaulters = (props) => (
  <Table style={style.Table}>
    <TableHead style={style.Head}>
      <TableRow style={style.TableRow}>
        {['Rate Defaulters', 'Projects'].map((item, index) => {
          return (
            <TableCell key={index} style={style.TableCellP}>
              {item}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
    <TableBody style={style.Body}>
      {props.rate_defaulters.map((defaulters, index) => {
        return (
          <TableRow key={index} style={style.TableRow}>
            <TableCell style={style.TableCellP}>{defaulters.resource}</TableCell>
            <TableCell style={style.TableCellP}>{defaulters.project}</TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);
